import useModalAside from '@use/useModalAside/useModalAside';
import Basket from '@components/Basket/Basket.vue';
import { ref } from 'vue';

export default function useBasketState() {
  const isOpen = ref(false);
  const modalAside = useModalAside();

  const open = (callBack?: () => unknown) => {
    modalAside.show(
      Basket,
      {},
      {
        afterRemove: () => {
          if (typeof callBack === 'function') {
            callBack();
          }
        },
      }
    );
    isOpen.value = true;
  };
  const close = async () => {
    // modalAside.hide();
    await modalAside.hide();
    isOpen.value = false;
  };
  return {
    // isOpen,
    open,
    close,
  };
}
